var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_WeightHandling"),
        width: "1200px",
        top: "5vh",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { width: "100%" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-width": "80px", "label-position": "left" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-form-item", {
                    attrs: {
                      "label-width": "250px",
                      label: _vm.$t("CargoMsg.Cargo_Tip")
                    }
                  }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        "label-position": "right",
                        "label-width": "50px",
                        label: _vm.$t("CargoMsg.Cargo_Warehouse")
                      }
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "cargoTerminalOperation",
                          props: { checkStrictly: true },
                          options: _vm.cargoTerminalOperationArray,
                          clearable: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.cargoTerminalOperationChange(p)
                          }
                        },
                        model: {
                          value: _vm.from.cargoTerminalOperation,
                          callback: function($$v) {
                            _vm.$set(_vm.from, "cargoTerminalOperation", $$v)
                          },
                          expression: "from.cargoTerminalOperation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "left",
                  display: "flex",
                  width: "100%"
                }
              },
              [
                _c("el-input", {
                  staticClass: "input-border",
                  staticStyle: { width: "550px", "padding-right": "5px" },
                  attrs: { no: "inputText" },
                  on: { input: _vm.inputTextChange },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.okHandler($event)
                    }
                  },
                  model: {
                    value: _vm.page.inputText,
                    callback: function($$v) {
                      _vm.$set(_vm.page, "inputText", $$v)
                    },
                    expression: "page.inputText"
                  }
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-right": "5px",
                      "text-align": "left"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "padding-bottom": "3px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.okHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c("el-button", { on: { click: _vm.resetHandler } }, [
                          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _c("el-button", { on: { click: _vm.onCancel } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DisableOpen")))
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "text-align": "right", width: "30%" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "60px" },
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.readScaleHandler(0)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReadScale")))]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "60px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.takePhotoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TakePhoto")))]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "60px" },
                    attrs: { type: "success" },
                    on: { click: _vm.saveHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("div", { staticStyle: { display: "flex", width: "100%" } }, [
        _c(
          "div",
          { staticClass: "section", staticStyle: { width: "40%" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { width: "100%" },
                attrs: { "label-position": "left", "label-width": "80px" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { height: "30px", "vertical-align": "middle" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "20px",
                          "padding-right": "5px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WeightRecord")))]
                    ),
                    _c("el-button", { on: { click: _vm.emptyCancel } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))
                    ]),
                    _c("el-button", { on: { click: _vm.historyHandler } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_History")))
                    ])
                  ],
                  1
                ),
                _c("div", { staticClass: "scrollable-div" }, [
                  _c(
                    "table",
                    {
                      staticClass: "table",
                      staticStyle: { width: "100%", "table-layout": "fixed" }
                    },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.page.list, function(item, index) {
                          return _c("div", { key: index }, [
                            _c("tr", { staticStyle: { width: "100%" } }, [
                              _c(
                                "td",
                                {
                                  staticStyle: { width: "50%" },
                                  attrs: { colspan: "2" }
                                },
                                [_vm._v(_vm._s(item.serialNumber))]
                              ),
                              _c(
                                "td",
                                {
                                  staticStyle: { width: "50%" },
                                  attrs: { colspan: "2" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_Weighing") +
                                        item.weighbridgeWeight +
                                        "KG"
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c("tr", [
                              _c("td", { attrs: { colspan: "4" } }, [
                                _vm._v(_vm._s(item.warehouseNo))
                              ])
                            ]),
                            _c("tr", { staticStyle: { width: "100%" } }, [
                              _c("td", { staticStyle: { width: "200px" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_TareWeight") +
                                      item.tareWeight
                                  )
                                )
                              ]),
                              _c("td", { staticStyle: { width: "200px" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_NetGrossWeight") +
                                      item.weight +
                                      " KG"
                                  )
                                )
                              ]),
                              _c("td", { staticStyle: { width: "200px" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_ItemsNBR") +
                                      item.quantity
                                  )
                                )
                              ]),
                              _c("td", { staticStyle: { width: "200px" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_GrossWeight2") +
                                      item.grossWeight
                                  )
                                )
                              ])
                            ]),
                            _c("hr")
                          ])
                        }),
                        0
                      )
                    ]
                  )
                ])
              ]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { "padding-right": "5px" } }),
        _c(
          "div",
          { staticClass: "section", staticStyle: { width: "35%" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { width: "100%" },
                attrs: { "label-position": "left", "label-width": "80px" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { height: "30px", "vertical-align": "middle" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "20px",
                          "padding-right": "5px"
                        }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_ScalePhoto")))]
                    ),
                    _c("div", { staticStyle: { "padding-top": "6px" } }),
                    _c(
                      "div",
                      { staticClass: "scrollable-div" },
                      _vm._l(_vm.photosList, function(item, index) {
                        return _c("div", { key: index }, [
                          _c("img", {
                            staticStyle: { width: "370px", height: "250px" },
                            attrs: { src: item }
                          })
                        ])
                      }),
                      0
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { "padding-right": "5px" } }),
        _c(
          "div",
          { staticClass: "section", staticStyle: { width: "24%" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { width: "100%" },
                attrs: { "label-position": "left", "label-width": "80px" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { height: "30px", "vertical-align": "middle" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          color: "blue",
                          "font-size": "20px",
                          "padding-right": "5px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_ScaleReading") + "(KG)"
                          )
                        )
                      ]
                    ),
                    _c("el-checkbox", {
                      attrs: { no: "weighbridgeReading" },
                      model: {
                        value: _vm.page.weighbridgeReading,
                        callback: function($$v) {
                          _vm.$set(_vm.page, "weighbridgeReading", $$v)
                        },
                        expression: "page.weighbridgeReading"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "1px" } },
                  [
                    !_vm.page.weighbridgeReading
                      ? _c("auto-number-input", {
                          attrs: {
                            no: "weighbridgeReading",
                            precision: 1,
                            min: 0
                          },
                          on: {
                            change: function(p) {
                              _vm.weightChange(p)
                            }
                          },
                          model: {
                            value: _vm.from.weighbridgeNo,
                            callback: function($$v) {
                              _vm.$set(_vm.from, "weighbridgeNo", $$v)
                            },
                            expression: "from.weighbridgeNo"
                          }
                        })
                      : _vm._e(),
                    _vm.page.weighbridgeReading
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              "font-size": "18px",
                              color: "blue"
                            }
                          },
                          [_vm._v(_vm._s(_vm.from.weighbridgeNo))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("hr"),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-top": "5px",
                      "padding-bottom": "5px"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "24px",
                          "padding-right": "5px"
                        }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_WeightedInfo")))]
                    )
                  ]
                ),
                _c(
                  "span",
                  {
                    staticStyle: { "font-weight": "bold", "font-size": "20px" }
                  },
                  [_vm._v(_vm._s(_vm.from.weighbridgeNoSum || "--") + "KG")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "20px",
                      "padding-left": "20px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.from.tSum || "--") +
                        _vm._s(this.$t("CargoMsg.Cargo_Pallet3"))
                    )
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("el-form-item", {
                      attrs: {
                        "label-width": "100px",
                        label: this.$t("CargoMsg.Cargo_ItemsNBR")
                      }
                    }),
                    _c("el-form-item", {
                      attrs: {
                        "label-width": "100px",
                        label: this.$t("CargoMsg.Cargo_Pallet2")
                      }
                    }),
                    _c("el-form-item", {
                      attrs: {
                        "label-width": "100px",
                        label: this.$t("CargoMsg.Cargo_TareWeight") + "(KG)"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("auto-number-input", {
                      staticStyle: { width: "100px" },
                      attrs: { no: "quantity", precision: 0, min: 0 },
                      model: {
                        value: _vm.from.quantity,
                        callback: function($$v) {
                          _vm.$set(_vm.from, "quantity", $$v)
                        },
                        expression: "from.quantity"
                      }
                    }),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "100px" },
                      attrs: {
                        no: "palletNo",
                        "select-type":
                          _vm.selectTypeNames.basic_data_PalletConfiguration,
                        filterable: "",
                        clearable: true,
                        "static-options": _vm.palletConfigurationList,
                        "default-value": _vm.from.palletNo
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.from.palletNo = p.value
                          _vm.palletNoChange(p)
                        }
                      }
                    }),
                    _c("auto-number-input", {
                      staticStyle: { width: "120px" },
                      attrs: {
                        no: "tareWeight",
                        disabled: "",
                        precision: 0,
                        min: 0
                      },
                      model: {
                        value: _vm.from.tareWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.from, "tareWeight", $$v)
                        },
                        expression: "from.tareWeight"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "padding-top": "10px" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "24px"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.$t("CargoMsg.Cargo_NetGrossWeight") + "(KG)"
                          )
                        )
                      ]
                    )
                  ]
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "font-size": "40px",
                      color: "#66b966"
                    }
                  },
                  [_vm._v(_vm._s(_vm.from.weight))]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("el-form-item", {
                      attrs: {
                        "label-width": "100px",
                        label: this.$t("CargoMsg.Cargo_GrossWeight2")
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("auto-number-input", {
                      staticStyle: { width: "100px" },
                      attrs: { no: "quantity", precision: 0, min: 0 },
                      on: {
                        input: function(p) {
                          _vm.grossWeightChange(p)
                        }
                      },
                      model: {
                        value: _vm.from.grossWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.from, "grossWeight", $$v)
                        },
                        expression: "from.grossWeight"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }